module.exports = __webpack_public_path__ + "img/vaccine_form_bluebg.589d8c70.png";